import { isArray, isString } from './internal';

export default function isArrayOfStrings(items: unknown): items is string[] {
  return isArray(items) && items.every((item) => isString(item));
}
